import React from 'react'
import styles from './LabelInput.module.scss';

export const LabelInput = ({text}) => {
  return (
    <p className={styles.text}>{text}</p>
  )
}
